import React, { FC, useState, useEffect, memo, useContextSignal, createContext } from "../../../lib/teact/teact";
import LotSelect from "../ui/lotSelect";
import { buildLotteryDataFromTicket, buildPlayData, buildPlayDataXi234, parseBetMessage } from "./on789Utils";
import { LotteryLoaiCuoc, One789BetTypes, One789GameTypes, OneProfile, Price, TicketItem, TicketPlay, UserAccount } from "./oneTypes";
import './one789.scss'
import { divide } from "lodash";
import One789Info from "./one789Info";
import OneBetNumGrid from "./OneBetNumGrid";
import { OneAPi } from "./oneApi";
import Loading from "../ui/loading";
import Button from "../../ui/Button";
import { DEBUG } from "../../../config";
import MyTextInput from "../ui/myTextInput";
import LotCheckBox from "../ui/lotCheckBox";
import worker from "../setupWorker";
import ConfirmDialog from "../../ui/ConfirmDialog";
import { logError } from "../db/model/errorLogs";
import DropdownMenu from "../../ui/DropdownMenu";
import MenuItem from "../../ui/MenuItem";
import SaoKe from "./SaoKe";

export type oneMenuId = 'Relogin' | 'SaoKe' | 'DatCuoc'
type OwnProps = {
    mapResult: Map<string, any>,
    mainWorkingState: any,
    profile: any,
    onMenuClick: (id: oneMenuId) => void;
}
// 1️⃣ Xác định kiểu dữ liệu của context
export interface ChatContextType {
    showAlert: () => void;
}

// 2️⃣ Khởi tạo Context với kiểu dữ liệu đúng
export const PlayOne789Context = createContext<ChatContextType | null>(null)

const PlayOne789: FC<OwnProps> = ({
    mapResult,
    mainWorkingState,
    profile,
    onMenuClick,
}) => {
    const [state, setState] = useState({
        data: {} as TicketPlay,
        loaiSelected: One789BetTypes.De,
        isLoading: false,

        pricesMap: new Map<number, Map<string, number>>(),
        giaTran: mainWorkingState.one789.giaTran,
        khongCuocVuotGiaTran: false,
        showPlayDialog: false,
        curScreen: 'DatCuoc' as oneMenuId,
    })
    async function handleLoaiCuocChanged(e: React.ChangeEvent<HTMLSelectElement>) {
        if (state.curScreen == 'DatCuoc') {
            handleLoaiCuocChangedDatCuoc(e);
        } else {
            handleLoaiCuocChangedSaoKe(e);
        }
    }
    async function handleLoaiCuocChangedSaoKe(e: React.ChangeEvent<HTMLSelectElement>) {

    }

    async function handleLoaiCuocChangedDatCuoc(e: React.ChangeEvent<HTMLSelectElement>) {
        let betData: TicketPlay;
        let loai = One789BetTypes.De;
        switch (e.target.value as LotteryLoaiCuoc) {
            case 'De':
                betData = await buildTiketWithPrice(0, One789BetTypes.De);
                loai = One789BetTypes.De;
                break;
            case 'DeA':
                betData = await buildTiketWithPrice(0, One789BetTypes.DeA);
                loai = One789BetTypes.DeA;
                break;
            case 'Lo':
                betData = await buildTiketWithPrice(0, One789BetTypes.Lo);
                loai = One789BetTypes.Lo;
                break;
            case 'LoA':
                betData = await buildTiketWithPrice(0, One789BetTypes.LoA);
                loai = One789BetTypes.LoA;
                break;
            case 'Giai1':
                betData = await buildTiketWithPrice(0, One789BetTypes.G1);
                loai = One789BetTypes.G1;
                break;
            case 'Giai1A':
                betData = await buildTiketWithPrice(0, One789BetTypes.G1A);
                loai = One789BetTypes.G1A;
                break;
            case 'LoLive':
                betData = await buildTiketWithPrice(0, One789BetTypes.LoLive);
                loai = One789BetTypes.LoLive;
                break;
            case '3c':
                betData = await buildTiketWithPrice(0, One789BetTypes.D3);
                loai = One789BetTypes.D3;
                break;
            case 'Xi234':
                //betData = await buildTiketWithPrice(0, One789BetTypes.G1);
                //loai = 'Xien';
                const priceMap = new Map();
                priceMap.set('ALL', 530)
                betData = await buildPlayDataXi234(0, mapResult, priceMap);
                loai = One789BetTypes.X2;
                break;
        }
        setState(prev => ({ ...prev, data: betData, loaiSelected: loai }))
    }
    useEffect(() => {
        // buildTiketWithPrice(One789GameTypes.MB1, One789BetTypes.De).then(betData => {
        //     setState(prev => ({ ...prev, data: betData }))
        // })
        refreshOneInfo();
    }, [])
    async function buildTiketWithPrice(gameType: number, betType: number): Promise<TicketPlay> {
        setState(prev => ({ ...prev, isLoading: true }))
        let betData: TicketPlay = {
            IgnorePrice: false,
            Term: ""
        };
        if (betType == One789BetTypes.De) {
            const price = await OneAPi.price({ gameType: One789GameTypes.MB1, betType: One789BetTypes.De })
            addPrice(price);
            betData = buildPlayData(One789GameTypes.MB1, One789BetTypes.De, mapResult, price);

        } else if (betType == One789BetTypes.Lo) {
            const price = await OneAPi.price({ gameType: One789GameTypes.MB1, betType: One789BetTypes.Lo })
            addPrice(price);
            betData = buildPlayData(One789GameTypes.MB1, One789BetTypes.Lo, mapResult, price);

        } else if (betType == One789BetTypes.LoA) {
            const price = await OneAPi.price({ gameType: One789GameTypes.MB1, betType: One789BetTypes.LoA })
            addPrice(price);
            betData = buildPlayData(One789GameTypes.MB1, One789BetTypes.LoA, mapResult, price);

        } else if (betType == One789BetTypes.DeA) {
            const price = await OneAPi.price({ gameType: One789GameTypes.MB1, betType: One789BetTypes.DeA })
            addPrice(price);
            betData = buildPlayData(One789GameTypes.MB1, One789BetTypes.DeA, mapResult, price);

        } else if (betType == One789BetTypes.G1) {
            const price = await OneAPi.price({ gameType: One789GameTypes.MB1, betType: One789BetTypes.G1 })
            addPrice(price);
            betData = buildPlayData(One789GameTypes.MB1, One789BetTypes.G1, mapResult, price);

        } else if (betType == One789BetTypes.G1A) {
            const price = await OneAPi.price({ gameType: One789GameTypes.MB1, betType: One789BetTypes.G1A })
            addPrice(price);
            betData = buildPlayData(One789GameTypes.MB1, One789BetTypes.G1A, mapResult, price);

        } else if (betType == One789BetTypes.LoLive) {
            const price = await OneAPi.price({ gameType: One789GameTypes.MB1, betType: One789BetTypes.LoLive })
            addPrice(price);
            betData = buildPlayData(One789GameTypes.MB1, One789BetTypes.LoLive, mapResult, price);

        } else if (betType == One789BetTypes.D3) {
            const price = await OneAPi.price({ gameType: One789GameTypes.MB2, betType: One789BetTypes.D3 })
            addPrice(price);
            betData = buildPlayData(One789GameTypes.MB2, One789BetTypes.D3, mapResult, price);

        }
        setState(prev => ({ ...prev, isLoading: false }))
        return betData;
    }

    async function refreshOneInfo(): Promise<OneProfile> {
        setState(prev => ({ ...prev, isLoading: true }))
        const ret = profile;
        const profileApiCall = await OneAPi.profile();
        const recentBets = await OneAPi.recentBets();
        let gameType = One789GameTypes.MB1;
        if (state.loaiSelected == One789BetTypes.D3) {
            gameType = One789GameTypes.MB2;
        }
        const price = await OneAPi.price({ gameType: gameType, betType: state.loaiSelected })
        ret.profile = profileApiCall;
        ret.recentBets = recentBets;
        if (profileApiCall && Object.keys(profileApiCall).includes('Username'))
            setState(prev => ({ ...prev, profile: ret, isLoading: false }))
        addPrice(price)
        buildTiketWithPrice(One789GameTypes.MB1, state.loaiSelected).then(betData => {
            setState(prev => ({ ...prev, data: betData }))
        })
        return ret;
    }
    async function refreshRecentBetAndBalance(): Promise<OneProfile> {
        setState(prev => ({ ...prev, isLoading: true }))
        const ret = profile;
        const profileApiCall = await OneAPi.profile();
        const recentBets = await OneAPi.recentBets();
        const price = await OneAPi.price({ gameType: 0, betType: state.loaiSelected })
        ret.profile = profileApiCall;
        ret.recentBets = recentBets;
        if (profileApiCall && Object.keys(profileApiCall).includes('Username'))
            setState(prev => ({ ...prev, profile: ret, isLoading: false }))
        addPrice(price)

        return ret;
    }
    async function addPrice(price: Price[]) {
        const firstItem: Price = price[0];
        const loaiCuoc = firstItem.BetType;
        let curPriceMap = state.pricesMap.get(loaiCuoc);
        const tmp = state.pricesMap;
        if (curPriceMap == undefined) {
            curPriceMap = new Map<string, number>();
            tmp.set(loaiCuoc, curPriceMap);
        }

        for (let num of firstItem.Numbers) {
            curPriceMap.set(num.Number, num.ExtraPrice);
        }
        setState(prev => ({ ...prev, pricesMap: tmp }))
        if (DEBUG)
            console.log(tmp)
    }
    function buildRealPlayData() {
        let noData = false;
        if (state.data) {
            if (!state.data.Tickets) {
                noData = true;
            }
            if (state.data.Tickets == undefined || state.data.Tickets?.length == 0) {
                noData = true;
            } else {
                for (let ticket of state.data.Tickets!) {
                    if (ticket.Items) {
                        if (ticket.Items.length == 0) {
                            noData = true;
                        }
                    }
                }
            }
            if (noData) {
                worker.postMessage({ type: 'showsnackbar', data: 'chưa có số liệu, hãy dùng chức năng cân chuyển' });
            }
        }
        if (noData)
            return;
        const tmp = structuredClone(state.data);
        if (state.khongCuocVuotGiaTran) {

            for (let ticket of tmp.Tickets!) {
                if (ticket.Items) {
                    ticket.Items = ticket.Items!.filter((it: TicketItem) => {
                        return (it.Price <= state.giaTran)
                    })
                }
            }

        }
        //dùng payload này để cược vào mạng ld
        //console.log(tmp);
        return tmp;
    }
    function showDatCuocDialog() {
        setState(prev => ({ ...prev, showPlayDialog: true }))

    }
    function showAlert() {
        console.log('function in context: showAlert()')
    }
    return (
        <PlayOne789Context.Provider value={{ showAlert }}>
            <div className=" form-content one-dash-board">
                {
                    state.isLoading &&
                    <Loading size={'tiny'} />
                }
                <div className="common-container-row">
                    {state.curScreen == 'DatCuoc' &&
                        <LotSelect value={"De"} onChange={handleLoaiCuocChanged} id={""}>
                            <option value={'De'} selected={state.loaiSelected == One789BetTypes.De}>Đề</option>
                            <option value={'DeA'} selected={state.loaiSelected == One789BetTypes.DeA}>Đề A</option>
                            <option value={'Lo'} selected={state.loaiSelected == One789BetTypes.Lo}>Lô</option>
                            <option value={'LoA'} selected={state.loaiSelected == One789BetTypes.LoA}>Lô A</option>
                            <option value={'Giai1'} selected={state.loaiSelected == One789BetTypes.G1}>Nhất</option>
                            <option value={'Giai1A'} selected={state.loaiSelected == One789BetTypes.G1A}>Nhất A</option>
                            <option value={'Xi234'} selected={state.loaiSelected == One789BetTypes.X2}>Xiên 2,3,4</option>
                            <option value={'LoLive'} selected={state.loaiSelected == One789BetTypes.LoLive}>Lo live</option>
                            <option value={'3c'} selected={state.loaiSelected == One789BetTypes.D3}>3 càng</option>
                        </LotSelect>
                    }
                    {
                        state.curScreen == 'SaoKe' && <div> Sao kê</div>
                    }
                    <DropdownMenu positionX="right">
                        <MenuItem onClick={() => onMenuClick('Relogin')}>
                            Đăng nhập lại
                        </MenuItem>
                        <MenuItem onClick={() => {
                            setState(prev => ({ ...prev, curScreen: 'DatCuoc' }))
                        }}>
                            Đặt cược
                        </MenuItem>
                        <MenuItem onClick={() => {
                            setState(prev => ({ ...prev, curScreen: 'SaoKe' }))
                        }}>
                            Sao kê
                        </MenuItem>

                    </DropdownMenu>
                </div>

                {
                    state.curScreen == 'DatCuoc' && <>
                        <div className="common-container-row">
                            <MyTextInput label={"giá trần"} id={"gia-tran"} onChange={function (e: React.ChangeEvent<HTMLInputElement>): void {
                                let num = Number(e.target.value);
                                if (!isNaN(num)) {
                                    setState(prev => ({ ...prev, giaTran: num }))
                                }
                            }}
                                value={state.giaTran}
                            ></MyTextInput>
                            <LotCheckBox text="không cược vượt giá trần"
                                checked={state.khongCuocVuotGiaTran}
                                onChange={(e) => {
                                    setState(prev => ({ ...prev, khongCuocVuotGiaTran: e.target.checked }))
                                }}
                            ></LotCheckBox>
                            <Button size='smaller' round
                                onClick={refreshOneInfo}
                                color="translucent"
                            > <i className="fa fa-arrow-rotate-back"> </i></Button>
                            <Button size='smaller' round
                                onClick={showDatCuocDialog}
                                color="danger"
                            > <i className="fa fa-dice"> </i></Button>
                        </div>
                        <OneBetNumGrid data={state.data} priceMap={state.pricesMap} />
                        <One789Info oneProfile={profile} />
                    </>
                }
                {
                    state.curScreen == 'SaoKe' && <>
                        <SaoKe />
                    </>

                }
                <ConfirmDialog isOpen={state.showPlayDialog}
                    title="Xác nhận đặt cược"
                    text="Sau khi đặt cược sẽ không thể huỷ"
                    confirmLabel="Đặt cược"
                    confirmHandler={() => {
                        setState(prev => ({ ...prev, showPlayDialog: false, isLoading: true }))
                        const playData = buildRealPlayData();
                        //log tạm vào index db để theo dõi response trả về từ one789
                        if (playData) {
                            OneAPi.play(playData).then((res) => {
                                logError(JSON.stringify(res))
                                let cuocThanhCong = false;
                                if (res) {
                                    if (res.length > 0) {
                                        const it = res[0]
                                        if (it.Tx != '') {
                                            cuocThanhCong = true;
                                        }
                                    }
                                }
                                if (cuocThanhCong) {
                                    worker.postMessage({ type: 'showsnackbar', data: 'đặt cươc thành công' })
                                    const sms = buildLotteryDataFromTicket(playData);
                                    parseBetMessage(sms, mainWorkingState.CC.sendTo);
                                    setTimeout(() => {
                                        refreshRecentBetAndBalance();
                                    }, 3000)

                                } else {
                                    let message = 'Cược thất bại \n' + JSON.stringify(res);
                                    worker.postMessage({ type: 'showsnackbar', data: message })
                                }
                                setState(prev => ({ ...prev, isLoading: false }))
                            })

                        } else {
                            worker.postMessage({ type: 'showsnackbar', data: 'Không có số liệu' })
                            setState(prev => ({ ...prev, isLoading: false }))
                        }

                    }}
                    onClose={() => {
                        setState(prev => ({ ...prev, showPlayDialog: false }))
                    }}
                ></ConfirmDialog>
            </div >
        </PlayOne789Context.Provider>)
}

export default memo(PlayOne789);